import React, { Component } from "react";
import { Row, Col, Drawer, Input, AutoComplete, Card, Button, Badge, Modal, Search, Icon, Spin } from "antd";
import { Form } from '@ant-design/compatible';
import ListTaxNpi from "./ListNpiTax";
import DeleteModal from "./DeleteModal";
import BlankNpi from "../images/BlankNpi.svg";
import InvalidTax from "../images/InvalidTax.svg";
import AddNpiGroup from "./AddNpiGroup";
import Config from "../../config";
import axios from "axios";
import "./AddUser.css";

class GroupAdmin extends Component {
  constructor(props) {
    super(props);
    console.log("GroupAdmin",props)
    this.state = {
      accessNpis: [],
      searchNpis: false,
      filteredNpis: [],
      dataLoader: true,
      dataSource: [],
      isLoading: false,
      deleteModal: false,
      type: "new",
      showDrawer: false,
      placement: "bottom",
      NPIstate: "",
      totalTaxNPIs: [],
      ListOfNPIWithPlan: [],
      SelectedNPIList: [],
      value: "",
      combinations: [],
      selTaxId: null,
      selTaxNPIs: [],
      dummy: "",
      npisList: [],
      showList: false,
      selItemsComb: [],
      searchInput: "",
      savedNpiList: [],
    };
  }

componentDidMount() {
  this.setState({
      combinations: this.props.getCombinations ? this.props.getCombinations : [],
    savedNpiList: this.props.savedNpiList
      ? this.props.savedNpiList
      : "",
    dataLoader: false,
  }, () => {
    this.getParticularComb();
    // Preserve access-NPI filtering for Group User Tax ID searches.
    const taxNpiMapping = JSON.parse(
      sessionStorage.getItem("taxidNpiMapping") || "[]"
    );

    const requestedNpis = [];

    if (Array.isArray(taxNpiMapping)) {
      taxNpiMapping.forEach((item) => {
        if (Array.isArray(item.NPI)) {
          item.NPI.forEach((npi) => {
            if (!requestedNpis.includes(npi)) {
              requestedNpis.push(npi);
            }
          });
        }
      });
    }

    this.setState({
      accessNpis: requestedNpis,
    });
  });
}


  async validatePassKey(date) {
    // Format date as yyyy-MM-dd
    const formattedDate = new Date(date).toISOString().split('T')[0];
  
    const input = `${formattedDate}g2P4s8tCe3GZVbQW7FHnLU`;
  
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
  
    // await here
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashString = hashArray.map(b => String.fromCharCode(b)).join('');
    const base64Hash = btoa(hashString);
  
    return base64Hash;
  }
  getNpiListOnPlan = async () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
      },
    };
    let plan = sessionStorage.getItem("planName");

    let taxNpiMapping = JSON.parse(sessionStorage.getItem("taxidNpiMapping"));

    let requestedNpis = [];
    if (taxNpiMapping && taxNpiMapping.length > 0) {
      taxNpiMapping.map((item) => {
        if (item.NPI) {
          item.NPI.map((npi) => {
            if (!requestedNpis.includes(npi)) {
              requestedNpis.push(npi);
            }
          });
        }
      })
    }
    this.setState({ accessNpis: requestedNpis })
    let tmpArray = [];
    let npis = [];
    let url = `${Config.api}/ListNPIBasedOnPlan?PlanName=${plan}`;
    let payload = { "NpiNumber": requestedNpis };
    //  New condition
    if (this.props.List === "Registration") {
      let passKey = await this.validatePassKey(new Date());
      url = `${Config.api}/ListNPIBasedOnPlanForRegisterProvider?PlanName=${plan}`;
      payload = {
        "NpiNumber": requestedNpis || [],
        "tokenKey": passKey
      };
    }
       await axios.post(url, payload, axiosConfig).then((res) => {
        this.setState({
          dataLoader: true
        })
        let npiList = res.data.Details
        for (var i = 0; i < npiList.length; i++) {

          let name = npiList[i].providerType.toLowerCase() === "Physician".toLowerCase() ? `${npiList[i].firstName}${npiList[i].middleName ? ' ' + npiList[i].middleName : ''} ${npiList[i].lastName}` : npiList[i].facilityName

          tmpArray.push(name + "-" + npiList[i].npiNumber);
   
          //  when there is a more than one NPI list have
          const savedNpis = this.state.savedNpiList
            ? this.state.savedNpiList.split('|').map(npi => npi.trim())
            : [];
          for (let j = 0; j < savedNpis.length; j++) {
            if (savedNpis[j] == String(npiList[i].npiNumber)) {
              npis.push({ npi: npiList[i].npiNumber, name: name, save: true, delete: false })
            }
          }
          
          // if (this.state.savedNpiList.length > 0 && this.state.savedNpiList ==  String(npiList[i].npiNumber)) {
          //   npis.push({ npi: npiList[i].npiNumber, name: name, save: true, delete: false })
          // }
        };
      })
      .catch((er) => {
        console.log("er", er);
      }).finally(() => {
        let npiCombination = (this.state.combinations.filter(item => item.taxId === "None"))[0]
        if (npiCombination && this.state.savedNpiList.length > 0){ 
          npiCombination.npis = npis; 
        }
        this.setState({
          ListOfNPIWithPlan: tmpArray,
          combinations: this.state.combinations,
          dataLoader: false
        });
      })
  }

  OpenDrawer = async (value) => {
    await this.setState({
      showDrawer: !this.state.showDrawer,
      NPIstate: value == "TaxId" ? "TaxId" : "Npi",
      SelectedNPIList: [],
      selTaxNPIs: [],
      totalTaxNPIs: [],
      npisList: [],
      selTaxId: null,
      type: "new",
      showList: true
    });
  };

  setNpisList = (npis) => {
    this.setState({
      totalTaxNPIs: npis
    })
  }

  onBlurEvent = () => {
    this.setState({
      searchInput: "",
      searchNpis: false,
      filteredNpis: []
    });
  }

  onChange = (val) => {
    this.setState({
      searchInput: val,
      searchNpis: false
    })
    if (!val || !val.trim()) {
      this.setState({
        filteredNpis: []
      })
    }
  }

  anyValidation = (rule, value, callback) => {
    const { form } = this.props;
    let combination = this.state.selItemsComb.filter(item => item.taxId == value)
    if (combination.length > 0 && this.state.type === "new") {
      callback('This combination already exist!');
    }
    else callback();
  };

  checkUserRole = (role) => {
    let userRoles = sessionStorage.getItem("rolename") || "";
    return userRoles.includes(role);
  };

  validateTaxId = (taxId) => {
    if (this.checkUserRole("Group User") || this.checkUserRole("IPA User")) {
      let taxIDMapping = JSON.parse(sessionStorage.getItem("taxidNpiMapping"))
      let selectedItem = taxIDMapping.filter(item => item.TaxID == taxId)[0]
      if (!selectedItem) {
        return false
      } else return true

    } else return true
  }


  async validatePassKey(date) {
    // Format date as yyyy-MM-dd
    const formattedDate = new Date(date).toISOString().split('T')[0];
  
    const input = `${formattedDate}g2P4s8tCe3GZVbQW7FHnLU`;
  
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
  
    // await here
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashString = hashArray.map(b => String.fromCharCode(b)).join('');
    const base64Hash = btoa(hashString);
  
    return base64Hash;
  }

  onSearch = async (e) => {
    // this.props.form.validateFields(async (err, values) => {
    //   if (!err) {
    const headers = {
      Authorization: sessionStorage.getItem("access_token"),
      Accept: "application/json",
      "Content-type": "application/json",
    };
    let npisList = [];
    let promise;
    this.setState({ selTaxId: e })
    // if PA then ok, but if ipa user/ group user then check tax id belongingness
    if (!this.validateTaxId(e))
      return
    this.setState({
      isLoading: true,
      npisList: []
    })

    
    if(this.props.List !=="Registration"){

      promise = await fetch(`${Config.api}/ListNPIBasedOnTaxID?PlanName=${sessionStorage.getItem("planName")}`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        TaxId: [e],
        GroupTaxId: [e],
      })
    })
  }else{

    const passKey = await this.validatePassKey(new Date());
    promise = await fetch(`${Config.api}/ListNPIBasedOnTaxIDForRegisterProvider?PlanName=${sessionStorage.getItem("planName")}`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        TaxId: [e],
        GroupTaxId: [e],
        Tokenkey:passKey
      })
    })
    
  }

    let res = await promise.json();
    let npis = []
    let _selTaxNpis = []
    let roles = sessionStorage.getItem("rolename") || "";

    let filteredNpis = roles.includes("Group User")
      ? res.Details.filter(
        (item) =>
          this.state.accessNpis.includes(item.groupNPI) ||
          this.state.accessNpis.includes(`${item.providerNPI}`)
      )
      : res.Details;

    if(Array.isArray(filteredNpis)){

      filteredNpis.map((item) => {
        let name = `${item.firstName ? item.firstName : ""}${item.middleName ? ' ' + item.middleName : ''} ${item.lastName ? item.lastName : ""}`
        if (this.state.selTaxNPIs.findIndex(val => val.npi == item.providerNPI) < 0) {  // new case
          npis.push({ id: item.primaryTaxId, npi: item.providerNPI, groupNPI: item.groupNPI, name, delete: false, save: false })
        }
        else {
          if (this.state.type === "edit") {
            _selTaxNpis.push({ id: item.primaryTaxId, npi: item.providerNPI, groupNPI: item.groupNPI, name, delete: false, save: true }) //edit combination
          }
        }
        npisList.push({ id: item.primaryTaxId, npi: item.providerNPI, groupNPI: item.groupNPI, name, delete: false, save: false }) // not require delete & save
      });

      // let totalUniqueNPIs = []
      npis = npis.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.npi === value.npi
        ))
      )

      npisList = npisList.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.npi === value.npi
        ))
      )

      _selTaxNpis = _selTaxNpis.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.npi === value.npi
        ))
      )
      await this.setState({
        totalTaxNPIs: npis,
        showDrawer: true,
        selTaxId: e,
        selTaxNPIs: this.state.type === "edit" ? _selTaxNpis : this.state.selTaxNPIs,
        isLoading: false,
        npisList: npisList
      })
    }
    else {
      await this.setState({
        isLoading: false,
        npisList: []
      })
    }
    // }
    // })
  };

  handleSearch = async (val) => {
    const searchFor = val ? val.trim() : "";
            
  this.setState({
    filteredNpis: [],
    searchNpis: true,
  });

  if (!searchFor) {
    return;
  }

  this.setState({
    dataLoader: true,
  });

  try {
    const plan = sessionStorage.getItem("planName");

    const headers = {
      Authorization: sessionStorage.getItem("access_token"),
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    let url = `${Config.api}/ListNPIBasedOnPlan?PlanName=${plan}`;

    const payload = {
      NpiNumber: [searchFor],
    };

    // Preserve the existing Registration API behavior.
    if (this.props.List === "Registration") {
      const passKey = await this.validatePassKey(new Date());

      url = `${Config.api}/ListNPIBasedOnPlanForRegisterProvider?PlanName=${plan}`;

      payload.tokenKey = passKey;
    }

    const response = await axios.post(url, payload, {
      headers,
    });

    const npiList = Array.isArray(response.data.Details)
      ? response.data.Details
      : [];

    // const newList = npiList
    //   .filter((item) => item && item.npiNumber != null)
    //   .map((item) => {
    //     const name =
    //       item.providerType &&
    //       item.providerType.toLowerCase() === "physician"
    //         ? `${item.firstName || ""}${
    //             item.middleName ? " " + item.middleName : ""
    //           } ${item.lastName || ""}`.trim()
    //         : item.facilityName || "";

    //     return `${name}-${item.npiNumber}`;
    //   })
    //   .filter((item) => !item.toLowerCase().startsWith("undefined-"));
    
const newList = npiList
.filter((item) => item && item.npiNumber != null)
.map((item) => {
  const providerName = [
    item.firstName,
    item.middleName,
    item.lastName,
  ]
    .filter((part) => part && part.trim())
    .join(" ")
    .trim();

  const name = providerName || item.facilityName || "";

  return `${name}-${item.npiNumber}`;
})
.filter((item) => !item.startsWith("-"));


    const filteredNpis = newList.filter((item, index, self) =>
      item.toUpperCase().includes(searchFor.toUpperCase()) &&
      self.indexOf(item) === index
    );
  
    this.setState({
      ListOfNPIWithPlan: newList,
      filteredNpis,
      searchNpis: true,
    });
  } catch (error) {
    console.error("Error searching NPI:", error);

    this.setState({
      ListOfNPIWithPlan: [],
      filteredNpis: [],
      searchNpis: true,
    });
  } finally {
    this.setState({
      dataLoader: false,
    });
   }
  };

  removeTaxNPI = (item, type) => {
    let removedItem = this.state.selTaxNPIs.filter(val => val.npi === item.npi)[0]

    if (removedItem.save) removedItem.delete = true
    let index = this.state.selTaxNPIs.findIndex(val => val.npi === item.npi)

    const newList = this.state.selTaxNPIs.filter((val) => {
      return val.npi !== item.npi;
    });
    this.setState({
      selTaxNPIs: removedItem.save ? this.state.selTaxNPIs : [...newList],
      totalTaxNPIs: [...this.state.totalTaxNPIs, item],
    });
  };

  addTaxNPI = (item, type) => {
    if (type === "All") {
      let allItems = [...this.state.npisList]  //npisList has save false 
      for (let item of this.state.selTaxNPIs) {
        let index = allItems.findIndex(i => i.npi == item.npi)
        allItems[index].save = true  // to maintain save status
      }
      this.setState({
        selTaxNPIs: allItems,
        totalTaxNPIs: [] //as all npis are added
      });
    }
    else {
      //item is individual obj of npi
      // item.save = false // to add this
      item.delete = false // to add thisZZZ

      let itemExist = this.state.selTaxNPIs.filter(val => val.npi == item.npi)[0]
      if (itemExist) {
        // itemExist.save = false
        itemExist.delete = false
      }
      const newList = this.state.totalTaxNPIs.filter((val) => {
        return val.npi !== item.npi;
      });
      this.setState({
        totalTaxNPIs: newList,
        selTaxNPIs: itemExist ? [...this.state.selTaxNPIs] : [...this.state.selTaxNPIs, item]
      });
    }

  };

  closeDrawer = () => {
    this.setState({
      showDrawer: false,
      type: "new",
      filteredNpis: [],
      searchNpis: false,
      searchInput: "",
      SelectedNPIList: [],
      selTaxNPIs: [],
      totalTaxNPIs: [],
      npisList: [],
      selTaxId: null,
    });
    this.props.form.resetFields();
    this.getParticularComb();
  };

  getParticularComb = () => {
    // to remove those combinations & npis which are deleted
    let selectedComb = []
    this.state.combinations.forEach(item => {
      let _npis = []
      if (!item.delete) {
        for (let npi of item.npis) {
          if (!npi.delete) _npis.push(npi)
        }
        if (_npis.length > 0) selectedComb.push({ taxId: item.taxId, npis: _npis })
      }
    })
      // update state
  this.setState({ selItemsComb: selectedComb }, () => {
    //  Call parent callback here
    if (this.props.getsavedlistdate) {
      this.props.getsavedlistdate(this.state.selItemsComb);
    }
  });
     
  }

  showAddNPIs = () => {
    let selVal = this.state.combinations.filter(item => item.taxId === "None" && !item.delete)
    if (selVal && selVal.length > 0) return false
    else return true
  };

  seperateNPiandName = (str) => {
    // Extract only numbers
    const numbers = str.match(/\d+/g);

    // Extract only alphabets and spaces (ignore trailing "-")
    let alphabets = str.match(/[a-zA-Z\s-]+/g)?.join('').trim() || '';

    // Remove trailing hyphen if present
    alphabets = alphabets.replace(/-+$/, '').trim();

    const numberPart = numbers ? numbers.join('') : '';

    console.log("Numbers:", numberPart);
    console.log("Alphabets:", alphabets);
     // Return both values
  return {
    name: alphabets,
    npi: numberPart
  };
    

  }

  onSelect = (item) => {
     const { name, npi } = this.seperateNPiandName(item);
    //console.log(this.seperateNPiandName)
  this.setState((prevState) => {
    const existingIndex = prevState.SelectedNPIList.findIndex(
      (val) => String(val.npi) === String(npi)
    );

    let updatedList = prevState.SelectedNPIList.map((val) => ({
      ...val,
    }));

    if (existingIndex >= 0) {
      updatedList[existingIndex] = {
        ...updatedList[existingIndex],
        delete: false,
      };
    } else {
      updatedList.push({
        delete: false,
        save: false,
        name,
        npi,
      });
    }

    return {
      SelectedNPIList: updatedList,
      filteredNpis: [],
      searchNpis: false,
      searchInput: "",
    };
  });
};


  DeleteNPI = (item) => {
    if (item.save) {
      item.delete = true
      this.setState({
        SelectedNPIList: this.state.SelectedNPIList,
      });
    }
    else {
      let newNpis = this.state.SelectedNPIList.filter(val => val.npi != item.npi)
      this.setState({
        SelectedNPIList: [...newNpis],
      });
    }
  };

  submitHandler = () => {
    if (this.state.type === "edit") this.updateCombination();
    else this.addCombination();
    this.props.form.resetFields();
  };
  updateCombination = () => {
    if (this.state.NPIstate === "Npi") {
      let index = this.state.combinations.findIndex(item => item.taxId === "None")
     // this.state.combinations[index].npis = this.state.SelectedNPIList;
     if (index !== -1) {
      this.state.combinations[index].npis =
        this.state.SelectedNPIList.map((npi) => ({ ...npi }));
    }
    } else {  //TaxId
     // let index = this.state.combinations.findIndex(item => item.taxId === this.state.selTaxId) // have to update this
      let index = this.state.combinations.findIndex(
        item => item.taxId === this.state.selTaxId && item.delete !== true
      );
      this.state.combinations[index].npis = this.state.selTaxNPIs
    }
    this.setState({
      combinations: this.state.combinations,
      showDrawer: false
    })
    this.props.setCombinations(this.state.combinations)
    this.getParticularComb()
  };
  addCombination = () => {
    if (this.state.NPIstate === "TaxId") {
      this.state.combinations.push({ taxId: this.state.selTaxId, npis: this.state.selTaxNPIs, delete: 0, save: 0 })
    }
    else {
      this.state.combinations.push({ taxId: 'None', npis: this.state.SelectedNPIList, delete: false, save: false })
    }
    this.closeDrawer()
    this.props.setCombinations(this.state.combinations)
  };
  showModal = () => {
    this.setState({
      deleteModal: !this.state.deleteModal
    })
  };

  deleteCombination = () => {
    let newCombinations = []
    let deletedItem = {}
    if (this.state.NPIstate === "Npi") {
      deletedItem = this.state.combinations.filter(item => item.taxId === "None")[0]
    } else deletedItem = this.state.combinations.filter(item => item.taxId == this.state.selTaxId)[0]

    if (deletedItem.save) {  // this comb is saved in DB
      deletedItem.delete = true
      deletedItem.taxId = this.state.NPIstate === "Npi" ? "Deleted" : deletedItem.taxId
    }
    else {
      if (this.state.NPIstate === "Npi")
        newCombinations = this.state.combinations.filter(item => item.taxId != "None")
      else
        newCombinations = this.state.combinations.filter(item => item.taxId != this.state.selTaxId)
    }

    this.setState({
      combinations: deletedItem.save ? this.state.combinations : [...newCombinations],
      showDrawer: false,
      selTaxId: ""
    }, () => {
      this.getParticularComb()
      this.props.setCombinations(this.state.combinations)
      this.showModal()
    })

    // this.props.setDeletedCombinations(deletedItem)
    // this.props.setCombinations(newCombinations)
  };

  
editCombination = (item) => {
  const rawResponse = this.props.npiListForGroupUserNpi;
  console.log("raww",rawResponse)

  // Support either the Details array or the complete API response.
  const npiDetails = Array.isArray(rawResponse)
    ? rawResponse
    : Array.isArray(rawResponse?.Details)
    ? rawResponse.Details
    : [];

  console.log("API NPI details:", npiDetails);
  console.log("Selected combination:", item);

  // Normalize NPI numbers so number/string differences don't matter.
  const normalizeNpi = (value) =>
    value == null ? "" : String(value).trim();

  const npiDetailsMap = new Map(
    npiDetails.map((provider) => [
      normalizeNpi(provider.npiNumber),
      provider,
    ])
  );

  const draftNpis = (item.npis || []).map((npi) => {
    const provider = npiDetailsMap.get(
      normalizeNpi(npi.npi ?? npi.npiNumber ?? npi.NPINumber)
    );

    if (!provider) {
      console.warn("No API match found for NPI:", npi);
      return { ...npi };
    }

    const fullName = [
      provider.firstName,
      provider.middleName,
      provider.lastName,
    ]
      .filter(Boolean)
      .join(" ");

    const name = fullName || provider.facilityName || "";

    console.log("Matched NPI:", provider.npiNumber, "Name:", name);

    return {
      ...npi,
      name,
    };
  });

  this.setState({
    selTaxNPIs: item.taxId !== "None" ? draftNpis : [],
    SelectedNPIList: item.taxId === "None" ? draftNpis : [],
    type: "edit",
    selTaxId: item.taxId === "None" ? null : item.taxId,
    showList: true,
    NPIstate: item.taxId === "None" ? "Npi" : "TaxId",
    showDrawer: true,
  });

  if (item.taxId && item.taxId !== "None") {
    this.onSearch(item.taxId);
  }
};



  render() {
    const { Search } = Input;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="pt-2">
        <div className="px-2">
          <Row justify="space-between" type="flex">
            <Col className="question-css">
              {this.state.combinations.length > 0 ? (
                <b>
                  List of Combinations
                </b>
              ) : (
                <b>
                  Please create your combination of Tax ID & NPIs by clicking
                  “Add”
                </b>
              )}
            </Col>
            <Col className="gutter-row">
              <button
                type="text"
                className="butto-alluser"
                onClick={() => this.OpenDrawer("TaxId")}
              >
                Add Tax ID
              </button>
              {this.showAddNPIs()  && this.props.selectrole !== "Provider"  && <button
                className="butto-alluser ml-3"
                onClick={() => this.OpenDrawer("Npi")}
              >
                Add NPIs
              </button>}
            </Col>
          </Row>
        </div>
        {/* Drawer Starts from here */}

        <Drawer style={{borderRadius:"28px 28px 0px 0px"}}
          className="custom-drawer"
          placement={this.state.placement}
          closable={false}
          // onClose={this.props.onClose}
          open={this.state.showDrawer}
          key={this.state.placement}
          height="90%"
        >
          <div className="px-4 mb-2 pb-3">
            {this.state.NPIstate === "TaxId" ? (
              <Col style={{ marginTop: "20px" }}>
                <Form>
                  <Form.Item>
                    {getFieldDecorator("name", {
                      initialValue: this.state.selTaxId,
                      rules: [
                        {
                          required: true,
                          message: "   ",
                        },
                        { min: 9, message: 'Tax Id must have 9 digits.' },
                        { max: 9, message: 'Tax Id must have 9 digits only.' },
                        { validator: this.anyValidation },
                        {
                          pattern: new RegExp("^[0-9]*$"),
                          message: "Enter Numbers Only!",
                        }
                      ],

                    })(
                      <Search id="tax_button"
                        placeholder={
                          this.state.NPIstate === "TaxId"
                            ? "Enter Tax ID to search NPIs"
                            : "Enter and select NPI to add"
                        }

                        enterButton="Search"
                        size="large"
                        onSearch={this.onSearch}
                        style={{ height: "41px" }}
                      // maxLength="9"
                      // minLength="9"
                      />)}
                  </Form.Item>
                </Form>
              </Col>
            ) : (
              <Col style={{ marginTop: "20px" }} className="mb-2">
                <AutoComplete
  size="large"
  style={{ width: "100%" }}
  options={this.state.filteredNpis.map(item => ({ value: item }))}
  onSelect={this.onSelect}
  onBlur={this.onBlurEvent}
  filterOption={(inputValue, option) =>
    option.value.toUpperCase().includes(inputValue.trim().toUpperCase())
  }
  value={this.state.searchInput}
  onChange={this.onChange}
>
  <Input.Search
    style={{ height: "41px" }}
                      placeholder={
                        this.state.NPIstate === "TaxId"
                          ? "Enter Tax ID to search NPIs"
                          : "Enter and search NPI to add"
                      }
    enterButton="Search"
    size="large"
    onSearch={this.handleSearch}
    ref={input => { this.searchBar = input; }}
  />
</AutoComplete>
                {/* {this.state.searchNpis && this.state.filteredNpis.length === 0 && this.state.searchInput.trim() &&
                  <div style={{ color: "red" }}>
                    No record found!
                  </div>
                } */}

                {this.state.searchInput.trim() === "" && this.state.searchNpis &&
                  <div style={{ color: "red" }}>
                    Enter a valid NPI or Name to search!
                  </div>}
              </Col>
            )}
          </div>
          {/* Calling list Tax Npi component */}
          {this.state.NPIstate === "TaxId" &&
            <div className="pl-4 pt-2 mt-4">
              {(this.state.npisList.length > 0 && this.state.showList) || this.state.isLoading ?
                <ListTaxNpi
                  selTaxNPIs={this.state.selTaxNPIs}
                  totalTaxNPIs={this.state.totalTaxNPIs}
                  removeTaxNPI={this.removeTaxNPI}
                  addTaxNPI={this.addTaxNPI}
                  isLoading={this.state.isLoading}
                  npisList={this.state.npisList}
                  setNpisList={this.setNpisList}
                /> :
                <div>
                  {this.state.npisList.length === 0 && this.state.selTaxId &&
                    <div style={{ textAlign: "center" }}>
                      <img src={InvalidTax}></img>
                      <div className="imgDesc mt-2">
                        {this.validateTaxId(this.state.selTaxId) ? "Please Check the Tax ID and Search Again" :
                          "You can only access yours Group Tax ID"}
                      </div>
                    </div>}
                  {this.state.npisList.length === 0 && !this.state.selTaxId &&
                    <div style={{ textAlign: "center" }}>
                      <img src={BlankNpi}></img>
                      <div className="imgDesc mt-2">
                        Please Enter & search Tax ID to get list of Associated NPIs
                      </div>
                    </div>}
                </div>}
           </div>}

            {this.state.NPIstate != "TaxId" && <div className="pl-4 pt-2 pr-4 pb-3">
            {this.state.dataLoader && <Row
              style={{
                textAlign: "center",
                marginTop: "30vh"
              }}>
              <Spin size="large" />
             </Row>}
            {!this.state.dataLoader && <div>
              {this.state.SelectedNPIList.length > 0 ? (
                <AddNpiGroup
                  NPIListData={this.state.SelectedNPIList}
                  DeleteNPI={this.DeleteNPI}
                  closeDrawer={this.closeDrawer}
                />
              ) : (
                <div style={{ textAlign: "center" }}>
                  <img className="mt-3" src={BlankNpi}></img>
                  <div className="imgDesc mt-2">
                    Please Enter NPI to see the availability
                  </div>
                </div>
              )}
            </div>}
          </div>
          }

          {/* Done and cancle Button for TaxId and NPI */}

          <Row className="m-4 pb-3" justify="space-between" type="flex">
            <Col>
              {this.state.type === "edit" &&
                <button
                  className="delete-alluser danger pl-4 pr-4"
                  onClick={this.showModal}
                >
                  Delete Combination
                </button>
              }
            </Col>
            <Col>
              <button
                className="cancle-button pl-4 pr-4"
                onClick={this.closeDrawer}
              >
                Cancel
              </button>
              {(this.state.selTaxNPIs.length > 0 ||
                this.state.SelectedNPIList.length > 0) &&
                (
                  // <Col span={12} pull={4}>
                  <button onClick={this.submitHandler} className="ml-3 butto-alluser pl-4 pr-4">{this.state.type === "edit" ? "Update" : "Done"}</button>
                  // </Col>
                )}
            </Col>
            {/* <Col span={11} pull={10}>
              <button
                className="cancle-button pl-4 pr-4"
                onClick={this.closeDrawer}
              >
                Cancel
              </button>
            </Col> */}

          </Row>
        </Drawer>

        <div>
          {/* added data loader for handling add npi comb, need to wait to filter names from npilist*/}
          {this.state.dataLoader && this.state.selItemsComb.length > 0 &&
            <Row style={{
              textAlign: "center",
              marginTop: "3vh"
            }}>
              <Spin size="large" />
            </Row>
          }
          {this.state.selItemsComb.length > 0 && !this.state.dataLoader &&
            this.state.selItemsComb.map((item, index) => {
              if (!item.taxId || !item.npis || !item.npis.length || item.npis.some(npiItem => !npiItem.npi)) {
                // if both taxId and npis are blank then don't show card
                return null;
              }
              return (
                <Card className="card-css py-2 mb-2 mt-4 px-3 mx-2" key={index} >
                  <Row>
                    <Col span={23} className="question-css">
                      <b>0{index + 1}. Tax ID: {item.taxId}</b>
                    </Col>
                    <Col span={1} className="question-css"><Button size="small" type="link" onClick={() => this.editCombination(item)} >Edit</Button></Col>
                    {item.npis.length > 0 && item.npis.length < 9 &&
                      <Col span={24} className="question-css pt-2 px-4"> <b>NPIs: </b>

                        {item.npis.map((val) => {
                          if (!val.delete) {
                            //return (<span key={val.npi} className="mx-3">{val.npi} {val.groupNPI}</span>)
                            return (<span key={val.npi} className="mx-3">{val.npi} </span>)
                          }
                        })}
                      </Col>}

                    {item.npis.length > 0 && item.npis.length >= 9 &&
                      <Col span={22} className="question-css pt-2 px-4"> <b>NPIs: </b>

                        {item.npis.slice(0, 8).map((val) => {
                          return (
                            <span className="mx-3" key={val.npi}>{val.npi}</span>)
                        })}
                      </Col>}
                    {item.npis.length > 0 && item.npis.length >= 9 &&
                      <Col span={2}>
                        <Badge
                          className="site-badge-count-109 custom-badge"
                          count={`+${item.npis.length - 8}`}
                          style={{ backgroundColor: '#1890ff', fontSize: "10px" }}
                        />
                      </Col>}


                  </Row>
                </Card>
              )
            })}
        </div>

        <DeleteModal
          deleteModal={this.state.deleteModal}
          handleCancel={this.showModal}
          handleOk={this.deleteCombination}
        />

      </div>
    );
  }
}

export default Form.create({ name: "GroupAdmin" })(GroupAdmin);